import React, { useEffect, useState } from "react"


export default function RefractiveServices(props) {




const [videoOption, setVideoOption] = useState(props.videosList.refractiveDefault)

const [farAwayPlayed, setFarAwayPlayed] = useState(false)
const [upClosePlayed, setUpClosePlayed] = useState(false)
const [rangePlayed, setRangePlayed] = useState(false)
const [standardPlayed, setStandardPlayed] = useState(false)

const rangeLens = 
        props.trifocalToricLens ? props.trifocalToricLens :
        props.trifocalLens ? props.trifocalLens :
        props.edofToricLens ? props.edofToricLens :
        props.edofLens ? props.edofLens :
        null;
  

//if EDOF or toric lens would be offered but astigmatism is too low to offer toric or monofococal+cri, then need to offer near and far for standard monofocal
let nearFarStandardMonofocal = 
  ((
    (props.trifocalLens || props.edofLens)
  && !props.toricLens)
  ||
  props.isBelowSmallestToricMin === true)
  ? true
  : false

  // console.log(nearFarStandardMonofocal)

// Update state whenever videosList changes (e.g. switching Spanish ↔ English)
useEffect(() => {
  props.setMonofocalSelected(false)
  props.setToricSelected(false)
  props.setBestSelected(false)
  props.setRefractive(false)
  props.setLensOption("Cataract vision")
  setVideoOption(props.videosList.refractiveCataract)
}, [props.spanish]);


const optionStyleTrue = {
    width: "90%",
    border: "1px solid #292929",
    margin: "10px auto 0 auto",
    color: "#292929",
    padding: "14px 8px",
    borderRadius: "5px",
    fontSize: "14px",
    fontWeight: "400",
    background: "#f1f1f1",
    display: "flex",
    justifyContent: "space-between",
    cursor: "pointer",
  }

  const optionStyleFalse = {
    width: "90%",
    border: "1px solid #bbb",
    margin: "10px auto 0 auto",
    color: "#888",
    padding: "14px 8px",
    borderRadius: "5px",
    fontSize: "14px",
    fontWeight: "400",
    background: "#FFF",
    display: "flex",
    justifyContent: "space-between",
    cursor: "pointer",
  }

  let pStyle = {
    fontSize: '14px',
    textAlign: 'left',
    margin: '0px 0 0px 0',
    // borderBottom: '1px solid #292929',
  }

  let nameStyle = {
    margin: '0',
  }

  let preferredStyle = {
    margin: '0',
    color: '#007bff',
    fontWeight: '600',
  }



  return (
    <>

        <div
          style={{
            position: "relative",
            width: "100%",
            maxWidth: "640px",
            margin: "0 auto",
            paddingTop: "56.2%", // 16:9 aspect ratio
          }}
        >
          <iframe
            src={videoOption} //&autoplay=1&muted=0
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
            title="introductionMovie"
          />
        </div>


      {/* Lens options */}

      <div>
        
        <div
          style={
            props.lensOption !== "Cataract vision" 
              ? optionStyleFalse
              : optionStyleTrue
          }
          onClick={() => {
            props.setMonofocalSelected(false)
            props.setToricSelected(false)
            props.setBestSelected(false)
            props.setRefractive(false)
            props.setLensOption("Cataract vision")
            setVideoOption(props.videosList.refractiveCataract)
          }}
        >
            {props.spanish === true ? 'Visión con cataratas': 'Cataract vision'}
        </div> 
        
      </div>

      {
        props.toricLens
        ? 
          <div>
            <div
              style={(!props.lensTargetNear && !props.bestSelected && props.lensOption !== "Cataract vision" && props.refractive === true) ? optionStyleTrue : optionStyleFalse}
              onClick={() => {
                props.setLensOption(props.toricLens.lens_name)
                props.setLensTargetNear(false)
                props.setBestSelected(false)
                props.setRefractive(true)
                if(farAwayPlayed === false && props.userType === 'qrpt'){
                  setVideoOption(props.videosList.refractiveToricFar +'&autoplay=1&muted=0')
                  setFarAwayPlayed(true)
                } else {
                  setVideoOption(props.videosList.refractiveToricFar)
                }
              }}
            >
              <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%',
                    }}
                >
                    <p style={nameStyle}> 
                        {props.spanish === true ? 'Vea mejor de lejos': 'See better far-away'}
                    </p>
                    <p style={preferredStyle}>
                        {
                          props.goalVision === "see better far-away"
                          ?
                          props.spanish === true ? 'Su vision preferida': 'Your vision preference'
                          : null
                        }
                    </p>
                </div>
              </div>


              <div
                style={(props.lensTargetNear  && props.lensOption !== "Cataract vision" && props.refractive === true)? optionStyleTrue : optionStyleFalse}
                onClick={() => {
                  props.setLensOption(props.toricLens.lens_name)
                  props.setLensTargetNear(true)
                  props.setBestSelected(false)
                  props.setRefractive(true)
                  if(upClosePlayed === false && props.userType === 'qrpt'){
                    setVideoOption(props.videosList.refractiveToricNear +'&autoplay=1&muted=0')
                    setUpClosePlayed(true)
                  } else {
                    setVideoOption(props.videosList.refractiveToricNear)
                  }
                }}
              >
                <div
                  style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: '100%',
                  }}
                >
                  <p style={nameStyle}> 
                      {props.spanish === true ? 'Vea mejor de cerca': 'See better up-close'} 
                  </p>
                  <p style={preferredStyle}>
                      {
                        props.goalVision === "see better up-close"
                        ?
                        props.spanish === true ? 'Su vision preferida': 'Your vision preference'
                        : null
                      }
                  </p>
                </div>
            </div>
          </div>

      : nearFarStandardMonofocal === true
      ? <div>
            <div
              style={(!props.lensTargetNear && !props.bestSelected && props.lensOption !== "Cataract vision") ? optionStyleTrue : optionStyleFalse}
              onClick={() => {
                props.setLensOption(props.monofocalLens.lens_name)
                props.setLensTargetNear(false)
                props.setBestSelected(false)
                props.setRefractive('sortof')
                if(farAwayPlayed === false && props.userType === 'qrpt'){
                    setVideoOption(props.videosList.refractiveFar +'&autoplay=1&muted=0')
                    setFarAwayPlayed(true)
                } else {
                  setVideoOption(props.videosList.refractiveFar)
                } 
              }}
            >
              
              <div 
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%',
                    }}
                >
                    <p style={nameStyle}> 
                        {props.spanish === true ? 'Vea mejor de lejos': 'See better far-away'}
                    </p>
                     <p style={preferredStyle}>
                        {
                          props.goalVision === "see better far-away"
                          ?
                          props.spanish === true ? 'Su vision preferida': 'Your vision preference'
                          : null
                        }
                    </p>
                </div>
              </div>


              <div
                style={(props.lensTargetNear  && props.lensOption !== "Cataract vision")? optionStyleTrue : optionStyleFalse}
                onClick={() => {
                  props.setLensOption(props.monofocalLens.lens_name)
                  props.setLensTargetNear(true)
                  props.setBestSelected(false)
                  props.setRefractive('sortof')
                  if(upClosePlayed === false && props.userType === 'qrpt'){
                    setVideoOption(props.videosList.refractiveNear +'&autoplay=1&muted=0')
                    setUpClosePlayed(true)
                  } else {
                    setVideoOption(props.videosList.refractiveNear)
                  }
                }}
              >
                <div
                  style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: '100%',
                  }}
                >
                  <p style={nameStyle}> 
                      {props.spanish === true ? 'Vea mejor de cerca': 'See better up-close'}
                  </p>
                    <p style={preferredStyle}>
                        {
                          props.goalVision === "see better up-close"
                          ?
                          props.spanish === true ? 'Su vision preferida': 'Your vision preference'
                          : null
                        }
                    </p>
                </div>
            </div>
          </div>

      : null
        

       }

        {
          (!props.trifocalLens && !props.trifocalToricLens && !props.edofLens && !props.edofToricLens)
          ? null
          : (!props.trifocalLens && !props.trifocalToricLens && (props.edofLens || props.edofToricLens)) // EDOF or EDOF toric but not Trifocal or Trifocal Toric
          ? 
            //EDOF range of vision
            <div
                style={props.bestSelected ? optionStyleTrue : optionStyleFalse}
                onClick={() => {
                    props.setLensOption(rangeLens?.lens_name)
                    props.setLensTargetNear(false)
                    props.setBestSelected(true)
                    props.setMonofocalSelected(false)
                    props.setRefractive(true)
                    if(rangePlayed === false && props.userType === 'qrpt'){
                      setVideoOption(props.videosList.refractiveEdof +'&autoplay=1&muted=0')
                      setRangePlayed(true)
                    } else {
                      setVideoOption(props.videosList.refractiveEdof)  // EDOF video
                    }
                }}
                >
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%',
                    }}
                >
                    <p style={nameStyle}> 
                        {props.spanish === true ? 'Tenga rango de visión': 'Have partial range-of-vision'}
                    </p>
                    <p style={preferredStyle}>
                      {
                        props.goalVision === "have range-of-vision"
                        ?
                        props.spanish === true ? 'Su vision preferida': 'Your vision preference'
                        : null
                      }
                    </p>
                </div>
            </div>
          :
            //Trifocal range of vision
            <div
                style={props.bestSelected ? optionStyleTrue : optionStyleFalse}
                onClick={() => {
                    props.setLensOption(rangeLens?.lens_name)
                    props.setLensTargetNear(false)
                    props.setBestSelected(true)
                    props.setMonofocalSelected(false)
                    props.setRefractive(true)
                    if(rangePlayed === false && props.userType === 'qrpt'){
                      setVideoOption(props.videosList.refractiveTrifocal +'&autoplay=1&muted=0')
                      setRangePlayed(true)
                    } else {
                      setVideoOption(props.videosList.refractiveTrifocal)  // Trifocal video
                    }
                }}
                >
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%',
                    }}
                >
                    <p style={nameStyle}> 
                        {props.spanish === true ? 'Tenga rango de visión': 'Have range-of-vision'}
                    </p>
                    <p style={preferredStyle}>
                      {
                        props.goalVision === "have range-of-vision"
                        ?
                        props.spanish === true ? 'Su vision preferida': 'Your vision preference'
                        : null
                      }
                    </p>
                </div>
            </div>
        }

         {


              (
                (!props.edofLens && !props.trifocalLens && !props.trifocalToricLens && !props.edofToricLens && !props.toricLens)
              )
              ? null
              :
              ((props.refractive === true && props.toricLens) || nearFarStandardMonofocal === false) ?
                <div
                  onClick={() => {
                      props.setLensOption(props.monofocalLens.lens_name)
                      props.setBestSelected(false)
                      props.setMonofocalSelected(false)
                      props.setRefractive(false)

                      if(standardPlayed === false && props.userType === 'qrpt'){
                        setVideoOption(props.videosList.standardLens +'&autoplay=1&muted=0')
                        setFarAwayPlayed(true)
                      } else {
                        setVideoOption(props.videosList.standardLens)
                      }
                  }}
                  style={
                      props.refractive === true || props.lensOption === "Cataract vision"
                      ? optionStyleFalse
                      : optionStyleTrue
                    }
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            width: '100%',
                        }}
                    >
                        <p style={nameStyle}> 
                            {props.spanish === true ? 'Cirugía básica de cataratas': 'Basic cataract surgery'}
                        </p>
                        <p style={preferredStyle}>
                          {
                            props.goalVision === "wear glasses full time"
                            ?
                            props.spanish === true ? 'Su vision preferida': 'Your vision preference'
                            : null
                          }
                        </p>
                    </div>
                    
                </div>
                : null
              }

          

    </>
  )
}






